import { Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { UiIconComponent } from '@shared/ui/icon/ui-icon.component';
import { ToastService } from './toast.service';
import { ToastType } from './toast.model';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [NgClass, UiIconComponent],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss'
})
export class ToastContainerComponent {
  readonly toastService = inject(ToastService);

  iconName(type: ToastType): string {
    const icons: Record<ToastType, string> = {
      success: 'shield',
      error: 'warning',
      warning: 'bell',
      info: 'search'
    };
    return icons[type];
  }

  toneClass(type: ToastType): string {
    const classes: Record<ToastType, string> = {
      success: 'border-emerald-200 bg-emerald-50 text-emerald-800',
      error: 'border-rose-200 bg-rose-50 text-rose-800',
      warning: 'border-taxi-200 bg-taxi-50 text-taxi-800',
      info: 'border-blue-200 bg-blue-50 text-blue-800'
    };
    return classes[type];
  }

  iconToneClass(type: ToastType): string {
    const classes: Record<ToastType, string> = {
      success: 'bg-emerald-100 text-emerald-700',
      error: 'bg-rose-100 text-rose-700',
      warning: 'bg-taxi-100 text-taxi-700',
      info: 'bg-blue-100 text-blue-700'
    };
    return classes[type];
  }
}
